import { createTheme } from '@mui/material/styles';

export default createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#061535', // Bleu foncé AgoraSearch
      dark: '#030a1a',
      light: '#0d2650',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#EF8F1C', // Orange AgoraSearch
      dark: '#d17510',
      light: '#f2a347',
      contrastText: '#ffffff',
    },
    success: {
      main: '#2e7d32', // Vert pour les succès
      dark: '#1b5e20',
      light: '#2E7D32',
    },
    warning: {
      main: '#ed6c02', // Orange pour les avertissements
      dark: '#e65100',
      light: '#E65100',
    },
    error: {
      main: '#d32f2f', // Rouge pour les erreurs
      dark: '#c62828',
      light: '#ef5350',
    },
    info: {
      main: '#0288d1', // Bleu info
      dark: '#01579b',
      light: '#03dac6',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#212121',
      secondary: '#616161',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      fontSize: '2.125rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          borderRadius: 8,
        },
        outlined: {
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
  },
});